import React from 'react';

/** Daily-quota booking: request a place for the day (no time grid). */
export default function BookingDailyPlace({ remaining, primary, onRequest }) {
  return (
    <div className="mt-3 space-y-2" data-testid="booking-daily-count">
      <p className="text-xs text-zinc-300">
        {remaining} place{remaining === 1 ? '' : 's'} remaining this day.
      </p>
      <button
        type="button"
        disabled={remaining <= 0}
        onClick={onRequest}
        className="w-full rounded-lg px-4 py-3 text-sm font-semibold text-white disabled:opacity-40"
        style={{ background: primary }}
      >
        Request a place for this day
      </button>
    </div>
  );
}
